import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Footer() {

    useEffect(() => {
        Aos.init({duration: 2000})
    }, [])

    return (
        <div className='footer'>
            <div>
                <div className='footer-links' >
                    <a href='https://www.linkedin.com/in/tosin-samuel-alagbada-95874b106/' target='_blank'><FontAwesomeIcon icon={["fab", "linkedin"]} /></a>
                    <a href='https://github.com/Alat-star' target='_blank'><FontAwesomeIcon icon={["fab", "github"]} /></a>
                    <a href='#' target='_blank'><FontAwesomeIcon icon={["fab", "twitter"]} /></a>
                    <a href='#' target='_blank'><FontAwesomeIcon icon={["fab", "facebook-f"]} /></a>
                    <a href='https://codepen.io/your-work' target='_blank'><FontAwesomeIcon icon={["fab", "codepen"]} /></a>
                </div>
           
                <p>Built by Tosin Alagbada</p>
            </div>
            
        </div>
    )
}

export default Footer
